module.exports = __webpack_public_path__ + "img/bigbank@2x.eb481f5.png";